import React, { useEffect, useState } from "react";
import Layout from "../../components/layout";
import { FaArrowLeft } from "react-icons/fa";

import styles from "./NewJobworkPage.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { route } from "../../static/route";
import { useAppDispatch } from "../../app/hooks";
import {
  fetchOrderPartiesData,
  fetchPartiesData,
  updateJobworksData,
} from "../../features/newJobwork/newJobworkSlice";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { IFormInput } from "../../types/jobwork";
import { POST } from "../../services/axios.service";
import FormStep1 from "../../components/newJobwork/FormStep1";
import FormStep2 from "../../components/newJobwork/FormStep2";

const NewJobworkPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { typeId } = useParams();

  const methods = useForm<IFormInput>();

  const { handleSubmit, reset, trigger } = methods;

  const [formStep, setFormStep] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [requestError, setRequestError] = useState<string | null>(null);

  const handleGoToBack = () => {
    if (formStep > 1) setFormStep(formStep - 1);
    else navigate(route.dashboard);
  };

  const handleNextStep = async () => {
    const isPartyValid = await trigger("party_id");
    const isTypeValid = await trigger("type");
    if (isPartyValid && isTypeValid) {
      setFormStep(formStep + 1);
    }
  };

  const onSubmit: SubmitHandler<IFormInput> = async (data) => {
    setIsLoading(true);
    setRequestError(null);

    try {
      if (data && data?.items?.length > 0) {
        await POST("/v1/worker/jobworks", {
          party_id: data.party_id,
          type: data.type,
          items: data.items,
        })
          .then(async (response: any) => {
            if (response.data.status === "success") {
              await dispatch(updateJobworksData(response.data.data || []));
              await reset();

              navigate(route.newJobworkList.replace(":typeId", typeId || "1"));
            } else {
              setRequestError(response.data.message);
            }
          })
          .catch((error: any) => {
            setRequestError(error.data.message);
          });
      } else {
        setRequestError("કૃપા કરીને ઓછામાં ઓછી એક આઈટમ ઉમેરો.");
      }
    } catch (error) {
      setRequestError("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.");
    }

    setIsLoading(false);
  };

  useEffect(() => {
    dispatch(fetchPartiesData({ type: parseInt(typeId || "1") }));
    dispatch(fetchOrderPartiesData());
  }, [typeId]);

  return (
    <Layout>
      <div className={styles.NewJobworkPage}>
        <div className="w-full px-10 h-[200px] text-center flex flex-col justify-center relative">
          <FaArrowLeft
            onClick={handleGoToBack}
            className="absolute top-5 left-5 text-3xl text-white border-2 border-white p-1 rounded-full"
          />

          <h1 className="text-4xl mt-6 font-bold text-white">
            {typeId === "1" ? "બાંધવાનું કામ ઉમેરો" : "ખોલવાનું કામ ઉમેરો"}
          </h1>
        </div>

        <div className="w-full relative mt-[70px] px-10 py-5 lg:mt-[20px]">
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              {formStep === 1 && <FormStep1 typeId={typeId} />}
              {formStep === 2 && <FormStep2 />}

              {requestError !== null && (
                <span className="text-red-500 text-center mt-8">
                  {requestError}
                </span>
              )}

              <button
                disabled={isLoading}
                className={`${
                  formStep === 1 ? "block" : "hidden"
                } mx-auto mt-8 shadow rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2`}
                type="button"
                onClick={handleNextStep}
              >
                {isLoading ? "રાહ જુઓ..." : "આગળ વધો"}
              </button>

              <button
                className={`${
                  formStep === 2 ? "block" : "hidden"
                } mx-auto mt-8 shadow rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2`}
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? "રાહ જુઓ..." : "પુરુ કરો"}
              </button>
            </form>
          </FormProvider>
        </div>
      </div>
    </Layout>
  );
};
export default NewJobworkPage;
